import Redirect from "feature/common/redirect/redirect";

export default Redirect
